export { DialogTitleProps, DialogIcon, DialogTitle } from "lib-core"
